<template>
  <div>
    <el-input
      v-model.trim="currentValue"
      class="float-el-input"
      size="mini"
      clearable
      :placeholder="
        params.filterParams.opertype === 3 ? '按回车搜索' : '输入过滤'
      "
      @input="handleChange"
      @keyup.enter.native="handleEnterClick"
    ></el-input>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentValue: '',
      isSearched: false
    }
  },
  created () {
    if (this.params) {
      const currentParentModel = this.params.currentParentModel()
      if (
        currentParentModel &&
        currentParentModel.filter &&
        this.params.filterParams.opertype === 3
      ) {
        this.isSearched = true
      }
    }
  },
  methods: {
    handleChange () {
      if (this.currentValue) {
        this.params.parentFilterInstance(instance => {
          instance.onFloatingFilterChanged('contains', this.currentValue)
        })
        return
      }
      this.params.parentFilterInstance(instance => {
        instance.onFloatingFilterChanged('contains', null)
      })
      if (this.isSearched && this.params.filterParams.opertype === 3) {
        this.isSearched = false
        this.params.enter()
      }
    },
    onParentModelChanged (parentModel, event) {
      // When the filter is empty we will receive a null value here
      if (!parentModel) {
        this.currentValue = ''
      } else {
        // if (
        //   event &&
        //   !('afterDataChange' in event) &&
        //   !('afterFloatingFilter' in event)
        // ) {
        //   if (this.params.filterParams.opertype === 3) {
        //     this.isSearched = true
        //   }
        // }
        this.currentValue = parentModel.filter
      }
    },
    handleEnterClick () {
      if (this.params.filterParams.opertype === 3) {
        this.isSearched = true
        this.params.enter()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .float-el-input {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(100% - 1px);
  display: flex;
  background: #fff;
  .el-input__inner {
    height: 29px;
    border-radius: 0;
    border-color: transparent;
    padding: 1px 7px !important;
    flex: 1;
    &:focus {
      border-color: #32b16c;
      & + .el-input__suffix {
        border-color: #32b16c;
        .el-input__clear {
          transform: translateX(-1px);
          background: #fff;
        }
      }
    }
  }
  .el-input__suffix {
    position: relative;
    display: inline-block;
    right: 0px;
    height: 27px;
    border: 1px solid transparent;
    border-left: 0;
    background: #fff;
  }
}
</style>
